
import { Modal, Typography, Image } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./DiscountModal.scss";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";
import Link from "next/link";
import PopupPremier from "../../../assets/images/Premierpopup01.png";
import IslamicPopupDesktop from "../../../assets/images/Pop-up-islamic.png";
import PricingPopup from "../../../assets/images/pricing-popup.png";
import NothingPopup from "../../../assets/images/Nothing square.png";
import iphone17Popup from "../../../assets/images/iPhone17seriesforpremier-01.png";

const DiscountModal = ({ openDiscountModal, showDiscountModal, mainPopup, premierPopup }) => {
  const userType = Cookies.get("user_type");
  const router = useRouter();

  const handleClick = (type) => {
    sessionStorage.setItem("promoPopup", true);
    if (type === "shop-now") {
      router.push("/electronics");
    } else {
      showDiscountModal(false);
    }
  };

  const getPopupImage = () => {
    switch (userType) {
      case "islamic":
        return window.innerWidth > 768
          ? IslamicPopupDesktop.src
          : IslamicPopupDesktop.src;
      case "premier":
        return premierPopup?.premier_popup_img || iphone17Popup.src;
      default:
        return mainPopup?.main_popup_img;
    }
  };

  const getModalClass = () => {
    switch (userType) {
      case "islamic":
        return "discount-card-modal";
      case "premier":
        return "discount-card-modal premier-modal";
      default:
        return "discount-card-modal";
    }
  };
  
  const getPopupLink = () => {
    switch (userType) {
      case "premier":
        return premierPopup?.premier_popup_url;
      case "islamic":
        return "/12-12";
      default:
        return (
          mainPopup?.main_popup_url
        );
    }
  };

  return (
    <Modal
      open={openDiscountModal}
      onCancel={() => handleClick("close")}
      footer={null}
      centered
      closable={false}
      bodyStyle={{ padding: 0 }}
      className={getModalClass()}
    >
      <div className="modal-image-container" style={{ position: "relative" }}>
        <Link href={getPopupLink()}>
          <Image
            src={getPopupImage()}
            preview={false}
            width="100%"
            height="100%"
            style={{ objectFit: "cover" }}
          />
        </Link>

        {/* 👇 Just the icon (no Button) */}
        <CloseOutlined
          onClick={() => handleClick("close")}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            cursor: "pointer",
            fontSize: 22,
            color: "black",
            cursor: "pointer",
            zIndex: 10,
          }}
        />
      </div>
    </Modal>
  );
};

export default DiscountModal;
